export const AccessMode = {
    Web: "web",
    App: "app",
}